const config = {
  API: 'https://60d1cbbb5b017400178f45f1.mockapi.io/api/v1',
}

export default config;
